import { cx } from "@emotion/css";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { htmlFormatter } from "src/formatters/htmlFormatter";

interface EllipsisTextProps {
	html: string;
	className?: string;
	fontSizeClassName?: string;
}

export const EllipsisText = ({ html, className, fontSizeClassName }: EllipsisTextProps) => {
	const { t } = useTranslation();
	const textRef = useRef<HTMLSpanElement>(null);
	const [isTruncated, setIsTruncated] = useState(false);
	const [isExpanded, setIsExpanded] = useState(false);

	useEffect(() => {
		const element = textRef.current;
		if (element) {
			if (element.scrollHeight > element.clientHeight) {
				setIsTruncated(true);
			} else {
				setIsTruncated(false);
			}
		}
	}, []);

	const toggleExpand = () => {
		setIsExpanded(!isExpanded);
	};

	return (
		<div className="flex flex-col">
			<span
				ref={textRef}
				className={cx(className, "text-ellipsis-2", {
					"text-ellipsis-expanded": isExpanded,
				})}
			>
				{htmlFormatter(html)}
			</span>
			{isTruncated && (
				<span
					onClick={toggleExpand}
					className={cx(fontSizeClassName, "text-primary-link")}
				>
					{t("commands.seeMore")}
				</span>
			)}
		</div>
	);
};
